import { useRef, useState, useEffect, useContext, createContext } from 'react';
import { Link, useLocation } from "react-router-dom";

import { Container, Stack, Button, TextField } from '@mui/material';

import axios from "axios";
import dayjs from 'dayjs';

import { API, MSG } from "./constantsFront";
import { MsgContext } from '../../App';

/**
 * 輸出要件・規制編集
 * @returns
 */

function G0262RoadMapEdit() {
  const [PublishDate, setPublishDate] = useState("");         //公開日時
  const [Content, setContent] = useState("");                 //内容
  const [PublishDateMsg, setPublishDateMsg] = useState("");   //入力チェック(公開日時)
  const [ContentMsg, setContentMsg] = useState("");            //入力チェック(内容)

  const [TermsMain, setTermsMain] = useState("");             //Edit画面表題
  const { msg, setMsg } = useContext(MsgContext);				      // エラーメッセージ
  let body = { authKey: API.API_KEY };

  //コピーをもとに追加(値:-1),編集(値:null)を判定する
  let flg_copyadd = null;
  //選択された利用規約IDを格納
  let select_road_id = '';

  //G0251のstateからデータを受け取る
  const location = useLocation();
  if (location.state != null) {
    select_road_id = location.state.ID;
    flg_copyadd = location.state.CopyAdd;
  }

  //初回読込チェック
  const refIsRoad = useRef(true);
  useEffect(() => {
    if (!refIsRoad.current) {
      return;
    }

    //追加、編集による分岐
    if (flg_copyadd == -1) {
      setTermsMain("輸出要件・規制 複製");
    } else {
      setTermsMain("輸出要件・規制 編集");
    }

    //データの表示
    getRoadMap();

    //初回読込フラグをfalseにセット
    refIsRoad.current = false;
  })

  //輸出要件・規制 取得(初期表示)
  async function getRoadMap() {
    try {
      body.roadid = select_road_id;
      let res = await axios.post("/m_road_map/select/auth", body)
      //データ取得チェック
      if (res.status !== 200) {
        return;
      } else {
        //DBからのデータをUIに表示
        let roadList = res.data.roadList;
        if (flg_copyadd !== -1) {
          setPublishDate(dayjs(roadList[0].publish_date).format('YYYY-MM-DD HH:mm:ss'));
        }
        setContent(roadList[0].content);
      }
    } catch (error) {
      console.log("輸出要件・規制 取得(例外発生)")
      console.log("error", error.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  //入力チェック
  function ValueCheck() {
    let errCnt = 0;

    if (!PublishDate) {
      setPublishDateMsg("公開日時は必須です。");
      errCnt++;
    } else {
      setPublishDateMsg("");
    };

    if (!Content.trim()) {
      setContentMsg("内容は必須です。");
      errCnt++;
    } else {
      setContentMsg("");
    };

    if (errCnt > 0) {
      return false;
    } else {
      return true;
    }
  }

  //輸出要件・規制 公開データのIDを渡す
  async function publishCheck() {
    try {
      console.log("輸出要件・規制 公開データID取得開始");
      let res = await axios.post("/m_road_map/select/publish/auth", body)
      if (res.status !== 200) {
        setMsg("データを正常に取得できませんでした。");
        return;
      } else {  //正常時
        console.log(res.data.road);
        //現在公開されているデータのID
        let publish_id = res.data.road[0].road_map_id;
        return publish_id;
      }
    } catch (error) {
      console.log("輸出要件・規制 公開データID取得完了(例外)");
      console.log("error : " + error.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  //保存処理
  async function register() {
    try {
      //入力値チェック
      if (!ValueCheck()) {
        return
      }

      console.log("保存処理開始");

      //DB保存用データ格納
      let csletr = {};
      csletr.road_id = select_road_id;
      csletr.publish_date = PublishDate;
      csletr.content = Content;
      //json形式に変換しbodyへ格納
      let arrStr = [];
      arrStr = JSON.stringify(csletr);
      body.arrStr = arrStr;

      //保存処理実行
      if (flg_copyadd == -1) {
        //追加
        const res = await axios.post("/m_road_map/insert/auth", body);
        //データ取得チェック
        if (res.status !== 200) {
          console.log("輸出要件・規制保存処理 終了(insert失敗)");
          setMsg("新規追加が失敗しました。もう一度入力してください。");
          return;
        } else {
          console.log("輸出要件・規制保存処理 終了(insert成功)");
        }
      } else {
        //公開データID取得
        let publish_id = await publishCheck();
        //操作対象データが現在の公開データならメッセージ表示
        if (select_road_id == publish_id) {
          setMsg("選択されたデータは現在公開中のため編集できません。\n「複製」から差分を作成してください。");
          return;
        }

        //編集
        const res = await axios.post("/m_road_map/update/auth", body);
        //データ取得チェック
        if (res.status !== 200) {
          console.log("輸出要件・規制保存処理 終了(update失敗)");
          setMsg("編集が失敗しました。もう一度入力してください。");
          return;
        } else {
          console.log("輸出要件・規制保存処理 終了(update成功)");
        }
      }

      //画面遷移
      return window.location.href = './G0261RoadMapList';
    } catch (error) {
      console.log("輸出要件・規制保存処理 終了(例外)");
      console.log("error:", error.message);
      setMsg(MSG.EXCEPTION);
    }
  }

  //プレビュー画面遷移処理
  function preview() {
    //入力値チェック
    if (!ValueCheck()) {
      return;
    }

    //window.open(別タブで開くため)とlocalStorageでのデータの受け渡し
    let roadDetail = {};
    roadDetail.content = Content;
    localStorage.setItem("roadpreview", JSON.stringify(roadDetail));
    window.open('./D007RoadMap', "roadpreview")
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">
              <Container maxWidth="lg">
                <Stack spacing={2}>

                  <h1>{TermsMain}</h1>

                  <TextField required id="publish_date"
                    value={PublishDate ?? ''}
                    label="公開日時"
                    type={'datetime-local'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    helperText={PublishDateMsg}
                    error={Boolean(PublishDateMsg == "" ? false : true)}
                    onChange={e => setPublishDate(e.target.value)}
                  />

                  <TextField required id="content"
                    value={Content ?? ''}
                    label="内容"
                    error={Boolean(ContentMsg == "" ? false : true)}
                    helperText={ContentMsg}
                    onChange={e => setContent(e.target.value)}
                    multiline
                    rows={15}
                  />

                  <Stack spacing={2} direction="row">
                    <Button component={Link} to={"/G0261RoadMapList"}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      戻る
                    </Button>

                    <Button onClick={register}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      保存
                    </Button>

                    <Button onClick={preview}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      プレビュー
                    </Button>
                  </Stack>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default G0262RoadMapEdit;